import { createAsyncThunk } from "@reduxjs/toolkit";
import { axiosClient, ENDPOINTS } from "../../services/common"; // Import endpoints from the common file

export const login = createAsyncThunk(
  "auth/login",
  async (payload, { rejectWithValue }) => {
    try {
      const response = await axiosClient.post(ENDPOINTS.LOGIN, payload);
      return response.data;
    } catch (error) {
      return rejectWithValue(
        error.response?.data || "An error occurred during login."
      );
    }
  }
);

export const signup = createAsyncThunk(
  "auth/signup",
  async (payload, { rejectWithValue }) => {
    try {
      const endpoint =
        payload.role === "buyer"
          ? ENDPOINTS.USER_SIGNUP
          : ENDPOINTS.CLIENT_SIGNUP;

      // Remove role from the payload before sending to the API
      const { role, ...apiPayload } = payload;
      const response = await axiosClient.post(endpoint, apiPayload);
      return response.data; // Return success message
    } catch (error) {
      // Return error message to the component for display
      return rejectWithValue(
        error.response?.data || "An error occurred during signup."
      );
    }
  }
);

// Create contact action
export const createContact = createAsyncThunk(
  "auth/createContact",
  async (payload, { rejectWithValue }) => {
    try {
      const response = await axiosClient.post(ENDPOINTS.USER_QUERY, payload);
      return response.data;
    } catch (error) {
      return rejectWithValue(
        error.response?.data || "An error occurred while creating contact."
      );
    }
  }
);

// Create request password action
export const requestPassword = createAsyncThunk(
  "auth/reset-request-password",
  async (payload, { rejectWithValue }) => {
    try {
      const response = await axiosClient.post(
        ENDPOINTS.PASSWORD_RESET_REQUEST,
        payload
      );
      return response.data;
    } catch (error) {
      return rejectWithValue(
        error.response?.data ||
          "An error occurred while sending a passwordrequest."
      );
    }
  }
);

// Create reset password action
export const resetPassword = createAsyncThunk(
  "auth/reset-password",
  async (payload, { rejectWithValue }) => {
    try {
      const response = await axiosClient.post(
        ENDPOINTS.PASSWORD_RESET,
        payload
      );
      return response.data;
    } catch (error) {
      return rejectWithValue(
        error.response?.data ||
          "An error occurred while sending a passwordrequest."
      );
    }
  }
);

// Fetching cities along with area
export const searchLocation = createAsyncThunk(
  "search-loc/",
  async (baseText, { rejectWithValue }) => {
    try {
      const response = await axiosClient.get(
        `${ENDPOINTS.SEARCH_LOCATION}/${baseText}`
      );
      return response.data;
    } catch (error) {
      return rejectWithValue(
        error.response?.data ||
          "An error occurred while fetching the DMA locations."
      );
    }
  }
);

// Get cities without area
   export const searchCities = createAsyncThunk(
    "search-cities",
     async (baseText,{rejectWithValue}) =>{
      try{
        const response = await axiosClient.get(
            `${ENDPOINTS.SEARCH_CITIES}/${baseText}`
        );
        return response.data;
      } catch (error){
        return rejectWithValue(
        error.response?.data ||
          "An error occurred while fetching the DMA locations."
      );
      }
     }
   )

//get all locations

export const getAllLocations = createAsyncThunk(
  "search-locations",
  async (payload, { rejectWithValue }) => {
    try {
      const response = await axiosClient.get(`${ENDPOINTS.GET_LOCATION}`);
      return response.data;
    } catch (error) {
      return rejectWithValue(
        error.response?.data ||
          "An error occurred while fetching the DMA locations."
      );
    }
  }
);

// buyer signup two factor
export const activateUserAccount = createAsyncThunk(
  "activate-user-account",
  async (payload, { rejectWithValue }) => {
    try {
      const response = await axiosClient.post(
        ENDPOINTS.ACTIVATE_USER_ACCOUNT,
        payload
      );
      return response.data;
    } catch (error) {
      return rejectWithValue(
        error.response?.data ||
          "An error occurred during activating the account."
      );
    }
  }
);

// user signup resend otp

export const userResendOtp = createAsyncThunk(
  "user-resend-otp",
  async (payload, { rejectWithValue }) => {
    try {
      const response = await axiosClient.post(
        ENDPOINTS.USER_RESEND_OTP,
        payload
      );
      return response.data;
    } catch (error) {
      return rejectWithValue(
        error.response?.data || "An error occurred during sending the otp."
      );
    }
  }
);
